import axios from 'axios';
import type { PeriodoActividadWorkflowPeriodo } from './workflow-periodo-config';

export type { PeriodoActividadWorkflowPeriodo, PeriodoSeleccionarRequest } from './workflow-periodo-config';
export {
  assignedPeriodosFromSelection,
  findPeriodoSeleccionarMatch,
  matchingHabilitadoPeriodoIds,
  parseConfigPeriodos,
  PERIODO_SELECCIONAR_EVENT,
  PERIODOS_CONFIG_WARNING_HELP,
  PERIODOS_CONFIG_WARNING_HELP_LINK,
  PERIODOS_EMPTY_WARNING_CHAT_MESSAGE,
  PERIODOS_MULTI_WARNING_CHAT_MESSAGE,
  openPeriodosConfigWarningHelp,
  periodoMatchesTipoNumero,
  periodoSeleccionar,
  periodoSeleccionarFailPayload,
  runOptionalPeriodoSeleccionarCallback,
  periodosConfigWarningChatPrompt,
  periodosConfigWarningMessage,
  periodosConfigWarningTitle,
  serializePeriodosForConfigSave,
} from './workflow-periodo-config';

export interface SyncPeriodoActividadWorkflowRequest {
  periodoActividadIds: number[];
}

export const WORKFLOW_PERIODO_API = 'api/profase-workflow-periodos';

export function workflowPeriodoActividadesUrl(workflowId: number): string {
  return `${WORKFLOW_PERIODO_API}/por-workflow/${workflowId}/periodo-actividades`;
}

/** Ids de catálogo ProfasePeriodoActividad asignados y vigentes al workflow. */
export async function fetchAssignedPeriodoActividadIds(
  workflowId: number,
): Promise<number[]> {
  const res = await axios.get<PeriodoActividadWorkflowPeriodo[]>(
    workflowPeriodoActividadesUrl(workflowId),
    { params: { asignado: true } },
  );
  return (Array.isArray(res.data) ? res.data : [])
    .filter(item => item.asignado)
    .map(item => item.id);
}
